"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
var _CustomIconOrImage = _interopRequireDefault(require("../../shared/CustomIconOrImage"));
var _useLocalTheme2 = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Container = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    & [class*='ContainerWithLabelstyle__LabelContainer'] {
      background-color: ${props === null || props === void 0 ? void 0 : props.bgColor};
      display: flex;
      justify-content: flex-start;
      & p {
        color: ${props === null || props === void 0 ? void 0 : props.color};
        font-weight: ${props === null || props === void 0 ? void 0 : props.fontWeight};
      }
    }
    & [class*='Interactionstyle__BlankInteraction']::after {
      content: ' ';
      border-color: ${props === null || props === void 0 ? void 0 : props.borderColor};
    }
  `);
const ProductMatch = _ref => {
  var _useLocalTheme;
  let {
    handset,
    handsetIndex
  } = _ref;
  const {
    matchValue,
    matchSpecs
  } = handset;
  const matchSpecDoNotDisplayed = (0, _useConfig.default)('productCatalog.matchSpecDoNotDisplayed', []);
  const containerWithLabelStyle = (0, _useLocalTheme2.default)(`recommendation.containerWithLabelStyle`, null);
  const {
    recommendation
  } = (_useLocalTheme = (0, _useLocalTheme2.default)()) !== null && _useLocalTheme !== void 0 ? _useLocalTheme : {};
  const hasElevation = (0, _useLocalTheme2.default)(`hasElevation`, true);
  const filteredSpecs = (0, _react.useMemo)(() => {
    //Memoize the filteredSpecs to avoid re-rendering
    return matchSpecs === null || matchSpecs === void 0 ? void 0 : matchSpecs.reduce((filteredArray, spec) => {
      if (spec.valueText && !matchSpecDoNotDisplayed.includes(spec.name)) {
        //Display the spec only if it has a valueText and is not in the matchSpecDoNotDisplayed
        //Calculate the displayText based on the spec description and valueText
        const displayText = spec.description ? _services.Services.locale.localeString(`Specs.${spec.description}`, spec.description) : `${_services.Services.locale.localeString(`Specs.${spec.name}`, spec.name)}: ${_services.Services.locale.localeString(`Specs.${spec.valueText}`, spec.valueText)}`;
        //Push the spec to the filteredArray
        filteredArray.push({
          ...spec,
          displayText
        });
      }
      return filteredArray || [];
    }, []);
  }, [matchSpecs, matchSpecDoNotDisplayed]);
  return matchValue && filteredSpecs.length ? /*#__PURE__*/_react.default.createElement(Container, containerWithLabelStyle, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: `${recommendation !== null && recommendation !== void 0 && recommendation.hideMatchValue ? '' : matchValue + ' '}${_services.Services.locale.localeString('Recommendation.MatchHeading')}`,
    level: 2,
    appearance: "secondary",
    paddingLevel: 3,
    dataAttributes: {
      'data-testid': `matching-percentage-title-${handsetIndex}`
    },
    elevation: hasElevation
  }, filteredSpecs.map((spec, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      layout: {
        sm: [2, 10],
        md: [1, 11]
      },
      spacing: 1,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      name: spec.iconName,
      size: 4
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, spec.displayText)), index < (matchSpecs === null || matchSpecs === void 0 ? void 0 : matchSpecs.length) - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  })))) : null;
};
var _default = ProductMatch;
exports.default = _default;